import React, { useState} from "react";
import { NavLink } from "react-router-dom";

function HamburgerMenu() {
  const [isOpen, setIsOpen] = useState(false);

  function handleClick() {
    if (isOpen === false) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }

  return (
    <div className={`HamburgerMenu`}>
      <div onClick={handleClick} className={`icon ${isOpen ? "active" : ""}`}>
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
      </div>
      <div className={`Nav ${isOpen ? "active" : ""}`}>
        <NavLink onClick={handleClick} to="/">Home</NavLink>
        <NavLink onClick={handleClick} to="about">About</NavLink>
        <NavLink onClick={handleClick} to="work">Work</NavLink>
        <NavLink onClick={handleClick} to="resume">Resume</NavLink>
      </div>
    </div>
  );
}

export default HamburgerMenu;